import React, {ReactElement} from 'react';

import Col from '../../common/Col';
import Row from '../../common/Row';
import {Link} from '../types';
import LinkButton from './buttons/LinkButton';
import {HelpButton} from './buttons/PillButtons';
import ModalButton from './ModalButton';

type HelpFindOutProps = {
  text?: string;
  links?: Link[];
};

const HelpFindOut = ({text, links}: HelpFindOutProps): ReactElement | null => {
  if (!text && !links) return null;
  return (
    <ModalButton title="Find out yourself" button={<HelpButton className="mobile:!p-2" />}>
      <Row className="my-8 text-center">
        <Col className="grow space-y-8">
          {text && <div className="text-2xl font-semibold mobile:text-xl">{text}</div>}
          {links && (
            <div>
              <div className="my-6 text-xl font-semibold mobile:text-base">
                For more information check the following links:
              </div>
              <Col className="space-y-6 ">
                {links.map((link: Link, idx: number) => (
                  <LinkButton key={`help-link-${idx}`} link={link} />
                ))}
              </Col>
            </div>
          )}
        </Col>
      </Row>
    </ModalButton>
  );
};

export default HelpFindOut;
